import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { weeksList } from '../../../Util';
import Divider from '@amzn/meridian/divider';
import UserInfoSelect from '../../Dashboard/DashboardComponents/UserInfoSelect';
import { TRAILING_DAYS } from '../../Dashboard/DashboardComponents/LighthouseMetrics/types';
import Box from '@amzn/meridian/box';
import { TeamProps } from './Types/types';

const ProfileHeader: React.FC<TeamProps> = ({
  teamProfile,
}: TeamProps): React.ReactElement => {
  return (
    <Box>
      <Row alignmentVertical='top' alignmentHorizontal='justify' width='100%'>
        <Row alignmentHorizontal='start' alignmentVertical='top'>
          <Heading level={1} type='h600'>
            <FormattedMessage id='cs_perfportal_team' defaultMessage='Team' />
          </Heading>
        </Row>

        <Row alignmentHorizontal='end' alignmentVertical='top'>
          <UserInfoSelect
            givenName={teamProfile.user.displayName}
            username={teamProfile.user.userName}
            weeks={weeksList()}
            selectedWeek={TRAILING_DAYS}
          />
        </Row>
      </Row>
      <Row width='100%' spacingInset='none' spacing='none'>
        <Divider />
      </Row>
    </Box>
  );
};

export default ProfileHeader;
